$(document).ready(function() {
      var homeBannerText = new Swiper('.js-banner-text', {
        spaceBetween: 10,
        loop: true,
        autoplay: true,
        speed: 3000,

        slidesPerView: 1,
        touchRatio: 0.2,
        // slideToClickedSlide: true,
        pagination: {
            el: '.js-custom-pagination',
            clickable: true,
        },
        loop: true,
        // loopedSlides: 4
    });   

   
})